import { makeResetStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCellSectionDecoratorStyle = makeResetStyles({
  width: '100%',
  height: '100%',
  '& .grid-cell-selection-decorator': {
    width: '100%',
    height: '100%',
    ...shorthands.overflow('hidden'),
  },
  '& .selected-checkbox': {
    position: 'absolute',
    top: '6px',
    right: '6px',
  },
  '& .selectedState': {
    outlineStyle: 'solid',
    outlineWidth: '4px',
    outlineColor: tokens.colorBrandBackground,
    ...shorthands.borderRadius('6px'),
  },
  '& .checkbox': {
    backgroundColor: tokens.colorNeutralForegroundInverted,
    zIndex: 2,
    width: '20px',
    height: '20px',
    ...shorthands.borderRadius(tokens.borderRadiusSmall),
    '& .fui-Checkbox__indicator': {
      width: '20px',
      height: '20px',
      ...shorthands.margin(0),
    },
  },
});
